import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import SectionTitle from '../../../../../Common/SectionTitle/SectionTitle';
import TestimonialsCarousel from '../../../Components/Carousels/TestimonialsCarousel/TestimonialsCarousel';
import * as classes from './TestimonialsSection.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { TestimonialsSectionProps } from '../../../../../Sections/AdditionalInfo/TestimonialsSection/TestimonialsSection';

const TestimonialsSection: FC<TestimonialsSectionProps> = ({ testimonials, slideChangeAction, activeSlide }) => {
  const { t } = useTranslation();
  return (
    <Section number='03' label={t('additionalInfo.testimonialsSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        <div className='row'>
          <div className='col-xl-5 col-lg-5 col-md-6 col-sm-5'>
            <SectionTitle>{t('additionalInfo.testimonialsSection.titleText')}</SectionTitle>
          </div>
          <div className='col-xl-7 col-lg-7 col-md-6 col-sm-7'>
            <div className={classes.carouselWrapper}>
              <div className={classes.carouselCounter}>{`${activeSlide + 1}/${testimonials.length}`}</div>
              <TestimonialsCarousel items={testimonials} slideChangeAction={slideChangeAction} />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default TestimonialsSection;
